import React from 'react';

// One inline icon set, as in ves-web: the same stroke width and viewBox for every icon, drawn in the text colour.
const base = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, 'aria-hidden': 'true' };

export const IconPolicy = () => (
  <svg {...base}><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z" /><path d="M9 12l2 2 4-4" /></svg>
);
export const IconMenu = () => (
  <svg {...base}><path d="M4 6h16M4 12h16M4 18h16" /></svg>
);
export const IconTerminal = () => (
  <svg {...base}><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M7 10l3 2-3 2M13 14h4" /></svg>
);
export const IconDevices = () => (
  <svg {...base}><rect x="3" y="4" width="18" height="12" rx="1.5" /><path d="M8 20h8M12 16v4" /></svg>
);
export const IconFindings = () => (
  <svg {...base}><path d="M12 3l9 16H3L12 3z" /><path d="M12 10v4M12 17h.01" /></svg>
);
export const IconActions = () => (
  <svg {...base}><path d="M5 12l5 5L20 7" /><path d="M4 5h6M4 19h6" /></svg>
);
export const IconDashboard = () => (
  <svg {...base}><rect x="3" y="3" width="7" height="9" rx="1" /><rect x="14" y="3" width="7" height="5" rx="1" /><rect x="14" y="12" width="7" height="9" rx="1" /><rect x="3" y="16" width="7" height="5" rx="1" /></svg>
);
